<template>
  <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
    <div class="row mt-3">
      <div class="col col-sm col-12 pt-2">
        <em class="fas fa-info-circle text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Información de Año Escolar Extendido
        </span>
      </div>
    </div>
    <div class="row py-3 mr-md-0">
      <div class="col-12 col-md-3">
        <span class="color-gray-6 d-block font-14">Fecha de Solicitud:</span>
        <span class="font-16 color-black">
          {{ data.requestedDate | date('DD/MMM/YYYY') }}
        </span>
      </div>
      <div class="col-12 col-md-3">
        <span class="color-gray-6 d-block font-14">Numero de Solicitud:</span>
        <span class="font-16 color-black">
          {{ data.requestNumber }}
        </span>
      </div>
      <div class="col-12 mt-3">
        <span class="color-gray-6 d-block font-14">Observación:</span>
        <span class="font-16 color-black">
          {{ data.comment }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AEEAdditionalInformation',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
